import { IComponentOptions } from 'angular';
import { StudentCreditGapsPanelCtrl } from './student-credit-gaps-panel.controller';

export const studentCreditGapsPanelComponent: IComponentOptions = {
  template: require('./student-credit-gaps-panel.html'),
  bindings: {
    school: '<',
    student: '<',
    studentDiffs: '=',
    studentGapPlans: '=',
    isRestricted: '<',
  },
  controller: StudentCreditGapsPanelCtrl,
};
